@if (clientMeldingen) {
  <mat-nav-list>
    <mat-list-item class="no-list-item-highlight allow-button-shadow-overflow"
      disableRipple>
      <div matListItemTitle class="mat-small">
        <h3 matSubheader class="no-padding-left subheader">Recente meldingen</h3>
      </div>
      <span matListItemMeta>
        <button mat-mini-fab
          color="accent"
          (click)="onAddClick()">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </mat-list-item>
    @for (melding of clientMeldingen; track getClientMeldingId($index, melding); let isLast = $last) {
      <mat-list-item (click)="onMeldingClick(melding)">
        <mat-icon matListItemIcon>{{ melding.getAuteurRol() | zahRolIcon }}</mat-icon>
        <div matListItemTitle>{{ melding.getContent() }}</div>
        <div matListItemLine class="mat-small">
          {{ melding.getAuteurRol() }} - {{ melding.getCreatieTijdstip() | date:'d MMMM yyyy HH:mm' }}
        </div>
        <button matListItemMeta
          [class.hidden]="!melding.isEditableBy(user) && !melding.isDeletableBy(user)"
          mat-icon-button
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()"
          class="center-vertically"
          [disableRipple]="true">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu"
          xPosition="before"
          overlapTrigger="true">
          @if (melding.isEditableBy(user)) {
            <a
              mat-menu-item
              (click)="onEditClick(melding)">
              <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
              <span>Wijzigen</span>
            </a>
          }
          @if (melding.isDeletableBy(user)) {
            <a
              mat-menu-item
              (click)="onDeleteClick(melding)">
              <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
              <span>Verwijderen</span>
            </a>
          }
        </mat-menu>
      </mat-list-item>
      @if (!isLast) {
        <mat-divider></mat-divider>
      }
    }
    @if (clientMeldingen.length === 0) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen meldingen voor deze cliënt</div>
      </mat-list-item>
    }
    <mat-divider></mat-divider>
  </mat-nav-list>
}
